import React, { useState, useEffect } from 'react';

import _ from 'lodash';
import Heading from '@tds/core-heading';
import DimpleDivider from '@tds/core-dimple-divider';
import Spinner from '@tds/core-spinner';

import {
  getContentfulData,
  contentfulFormConfig,
  getData
} from '../../contentful';
import request, { isAdmin } from '../../utils/request';

import { ContentWrapper, Box, TopbarWrapper } from '../../design/css';
import { getPathVariables } from '../../misc';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

import Table from './Table';
import Pagination from './Pagination';

const ContactCentreSalesRepDashboard = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { noOrders }
  } = localizedStrings;
  const locale = getPathVariables(window.location.pathname)[0];
  const config = {
    ...contentfulFormConfig,
    content_type: 'salesRepDashboard',
    locale
  };

  const { role_id: role } = request.getProfile();
  const isSalesSupport = [11, 12].includes(role);

  const [pageLayout, setPageLayout] = useState();
  const [ordersList, setOrdersList] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [pageLoading, setPageLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);

  const fetchOrders = () => {
    request
      .get(
        `/orders?type=CC&status=${
          isAdmin ? 'Submitted' : 'incomplete&status=Submitted'
        }&pageNumber=${pageNumber}&pageSize=${_.get(
          pageLayout,
          'ordersPerPage',
          10
        )}${isSalesSupport ? `&saleSupport=true` : ''}`
      )
      .then(response => {
        setOrdersList(_.get(response, 'data.results', []));
        setTotalOrders(_.get(response, 'data.totalCount', 0));
        setPageLoading(false);
      })
      .catch(() => {});
  };

  useEffect(() => {
    getContentfulData(config).then(res => {
      setPageLayout(getData(res));
      fetchOrders();
    });
  }, []);

  useEffect(() => {
    fetchOrders();
  }, [pageNumber]);

  return (
    <>
      <DimpleDivider />
      <ContentWrapper style={{ padding: '0 4rem' }}>
        {pageLoading && <Spinner spinning label="Loading Orders..." />}
        {!pageLoading && ordersList.length === 0 ? (
          <Heading level="h3">{noOrders}</Heading>
        ) : (
          <>
            {!pageLoading && (
              <>
                <Box
                  style={{
                    margin: '2rem',
                    border: '1px solid #e3e3e3'
                  }}
                >
                  <TopbarWrapper style={{ color: '#fff', fontWeight: '900' }}>
                    {`${_.get(pageLayout, 'tableTitle', '')} (${totalOrders})`}
                  </TopbarWrapper>
                  <Table
                    pageLayout={pageLayout}
                    data={ordersList}
                    fetchOrders={fetchOrders}
                  />
                </Box>
                <Pagination
                  ordersPerPage={_.get(pageLayout, 'ordersPerPage', 10)}
                  totalOrders={totalOrders}
                  pageNumber={pageNumber}
                  setPageNumber={setPageNumber}
                />
              </>
            )}
          </>
        )}
      </ContentWrapper>
    </>
  );
};

export default ContactCentreSalesRepDashboard;
